export default __webpack_public_path__ + "static/media/profile.893cd0dc.svg";